module.exports = __webpack_public_path__ + "img/金风科技LOGO.f37c8894.png";